module.exports = __webpack_public_path__ + "Flag-276.408f26d42b921c6445d2345242e34054.svg";